(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[604],{

/***/ 9194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lE": function() { return /* binding */ LOCALES; },
  "QT": function() { return /* binding */ useI18n; }
});

// UNUSED EXPORTS: DEFAULT_LOCALE, LOCALISATIONS, i18n

;// CONCATENATED MODULE: ./features/i18n/languages/en.ts
const EN = {
    russianLanguage: "Russian",
    englishLanguage: "English",
    draftLanguagesIsRequired: "This field is required",
    publishDraft: "Publish",
    publishDraftChanges: "Publish changes",
    unpublishDraft: "Unpublish",
    photosSection: "Photos",
    photosSectionLink: "/?tags=photo",
    resetDraft: "Revert",
    previewDraft: "Preview",
    deleteDraft: "Delete",
    draftLanguages: "Languages",
    draftPublishDate: "Publication date (ISO)",
    draftTags: "Tags",
    selectPlaceholder: "Select...",
    draftTitlePlaceholder: "Title",
    draftContentPlaceholder: "Your story...",
    continueDraftEditing: "Edit...",
    editDraft: "Edit",
    draftsMenuItem: "Drafts",
    newDraftMenuItem: "New draft",
    homeMenuItem: "Home",
    logOutMenuItem: "Log out",
    emptyPreview: "Empty preview",
    blogSection: "Blog",
    projectsSection: "Projects",
    projectsSectionLink: "/?tags=project",
    articlesSection: "Articles",
    articlesSectionLink: "/?tags=article",
    translationsSection: "Translations",
    translationsSectionLink: "/?tags=translation",
    loginLabel: "Login",
    loginAction: "Log in",
    passwordLabel: "Password",
    defaultPageTitle: "lsndr's blog",
    draftsPageTitle: "Drafts",
    newDraftPageTitle: "New draft",
    editDraftPageTitle: "Edit draft",
    thisIsTranslation: "This is translation",
    loginPageTitle: "Login",
    areYouSure: "Are you sure?",
    tagsMenu: "Tags",
    months: [
        [
            "January",
            "January"
        ],
        [
            "February",
            "February"
        ],
        [
            "March",
            "March"
        ],
        [
            "April",
            "April"
        ],
        [
            "May",
            "May"
        ],
        [
            "June",
            "June"
        ],
        [
            "July",
            "July"
        ],
        [
            "August",
            "August"
        ],
        [
            "September",
            "September"
        ],
        [
            "October",
            "October"
        ],
        [
            "November",
            "November"
        ],
        [
            "December",
            "December"
        ]
    ],
    openPost: "Open post",
    draftSecret: "Draft secret"
};

;// CONCATENATED MODULE: ./features/i18n/languages/ru.ts
const RU = {
    russianLanguage: "Русский",
    englishLanguage: "Английский",
    draftLanguagesIsRequired: "Заполните это поле",
    publishDraft: "Опубликовать",
    publishDraftChanges: "Опубликовать изменения",
    unpublishDraft: "Распубликовать",
    resetDraft: "Сбросить",
    previewDraft: "Предпросмотр",
    deleteDraft: "Удалить",
    draftLanguages: "Языки",
    draftPublishDate: "Дата публикации (ISO)",
    draftTags: "Тэги",
    selectPlaceholder: "Выбрать...",
    draftTitlePlaceholder: "Заголовок",
    draftContentPlaceholder: "История...",
    continueDraftEditing: "Править...",
    editDraft: "Править",
    draftsMenuItem: "Черновики",
    newDraftMenuItem: "Новая запись",
    homeMenuItem: "Домой",
    logOutMenuItem: "Выйти",
    emptyPreview: "Отсутствует превью",
    blogSection: "Блог",
    projectsSection: "Проекты",
    projectsSectionLink: "/?tags=проект",
    articlesSection: "Статьи",
    articlesSectionLink: "/?tags=статья",
    loginLabel: "Логин",
    loginAction: "Войти",
    passwordLabel: "Пароль",
    defaultPageTitle: "lsndr's блог",
    draftsPageTitle: "Черновики",
    newDraftPageTitle: "Новая запись",
    editDraftPageTitle: "Редактирование записи",
    loginPageTitle: "Вход",
    areYouSure: "Вы уверены?",
    photosSection: "Фото",
    photosSectionLink: "/?tags=фото",
    translationsSection: "Переводы",
    translationsSectionLink: "/?tags=перевод",
    thisIsTranslation: "Это перевод",
    tagsMenu: "Тэги",
    months: [
        [
            "Январь",
            "Января"
        ],
        [
            "Февраль",
            "Февраля"
        ],
        [
            "Март",
            "Марта"
        ],
        [
            "Апрель",
            "Апреля"
        ],
        [
            "Май",
            "Мая"
        ],
        [
            "Июнь",
            "Июня"
        ],
        [
            "Июль",
            "Июля"
        ],
        [
            "Август",
            "Авугста"
        ],
        [
            "Сентябрь",
            "Сентября"
        ],
        [
            "Октябрь",
            "Октября"
        ],
        [
            "Ноябрь",
            "Ноября"
        ],
        [
            "Декабрь",
            "Декабря"
        ]
    ],
    openPost: "Открыть пост",
    draftSecret: "Пароль черновика"
};

// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
;// CONCATENATED MODULE: ./features/i18n/index.ts



const LOCALES = [
    "en",
    "ru"
];
const DEFAULT_LOCALE = "ru";
const LOCALISATIONS = {
    en: EN,
    ru: RU
};
function i18n(locale, key) {
    return LOCALISATIONS[locale][key];
}
function isLocale(locale) {
    return locale in LOCALISATIONS;
}
function useI18n() {
    const router = (0,next_router.useRouter)();
    const locale = router.locale && isLocale(router.locale) ? router.locale : DEFAULT_LOCALE;
    return {
        i18n: (key)=>{
            return i18n(locale, key);
        },
        locale
    };
}


/***/ }),

/***/ 6596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button; },
  "a7": function() { return /* reexport */ CreatableSelect; },
  "l0": function() { return /* reexport */ Form; },
  "II": function() { return /* reexport */ Input; },
  "gx": function() { return /* reexport */ Textarea; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./features/ui/form/form.module.scss
var form_module = __webpack_require__(5344);
var form_module_default = /*#__PURE__*/__webpack_require__.n(form_module);
// EXTERNAL MODULE: ../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(8944);
;// CONCATENATED MODULE: ./features/ui/form/form.tsx




function createFormValuesObject(data) {
    const object = {};
    for (const item of data.entries()){
        if (item[0].endsWith("--json") && typeof item[1] === "string") {
            object[item[0].substr(0, item[0].length - 6)] = !item[1] ? null : JSON.parse(item[1]);
        } else {
            object[item[0]] = item[1];
        }
    }
    return object;
}
function Form(props) {
    const { onSubmit , className , style , apiRef , children  } = props;
    const ref = (0,react.useRef)(null);
    const onFormSubmit = (0,react.useCallback)((e)=>{
        const formElement = (e === null || e === void 0 ? void 0 : e.currentTarget) || ref.current;
        if (!formElement) {
            return;
        } else if (e) {
            e.preventDefault();
        }
        if (onSubmit) {
            onSubmit(createFormValuesObject(new FormData(formElement)));
        }
    }, [
        onSubmit
    ]);
    (0,react.useEffect)(()=>{
        if (apiRef) {
            apiRef.current = {
                submit: ()=>{
                    onFormSubmit();
                }
            };
        }
    }, [
        apiRef,
        onFormSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        ref: ref,
        method: "post",
        onSubmit: onFormSubmit,
        style: style,
        className: (0,clsx_m/* clsx */.W)((form_module_default()).form, className),
        children: children
    });
}

;// CONCATENATED MODULE: ./features/ui/form/input.tsx



function Input(props) {
    const { label , defaultValue , onChange , type , name , validationError  } = props;
    const id = (0,react.useMemo)(()=>Math.random().toString(16).substr(2), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (form_module_default()).input,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                name: name,
                type: type,
                id: id,
                onChange: onChange,
                defaultValue: defaultValue
            }),
            validationError && (Array.isArray(validationError) ? validationError : [
                validationError
            ]).map((error, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (form_module_default()).form__validationError,
                    children: error
                }, index))
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(597);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./features/ui/form/button.tsx






const Button = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { onClick , className , round , style , disabled , loading , block  } = props;
    const onElemClick = (0,react.useCallback)((e)=>{
        if (disabled || loading || !onClick) {
            return;
        }
        onClick(e);
    }, [
        onClick,
        disabled,
        loading
    ]);
    const baseProps = {
        ref,
        onClick: onElemClick,
        className: (0,clsx_m/* clsx */.W)((form_module_default()).button, style === "danger" && (form_module_default()).button_danger, style === "void" && (form_module_default()).button_void, style === "outlined" && (form_module_default()).button_outlined, loading && (form_module_default()).button_spinning, className, round && (form_module_default()).button_round, block && (form_module_default()).button_block)
    };
    if (props.type === "link") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            ...baseProps,
            href: props.href,
            target: props.target,
            children: props.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiLoader */.dAq, {
                size: "1em"
            }) : props.children
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            ...baseProps,
            type: props.type,
            children: props.loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiLoader */.dAq, {
                size: "1em"
            }) : props.children
        });
    }
});
Button.displayName = Object.keys({
    Button
})[0];

;// CONCATENATED MODULE: ./features/ui/form/textarea.tsx




function Textarea(props) {
    const { autoSize , className , defaultValue , name , placeholder , onInput , onKeyDown , required  } = props;
    const [elemData, setElemData] = (0,react.useState)();
    const updateElementSize = (0,react.useCallback)((elem, elemData)=>{
        elem.rows = 1;
        elem.rows = Math.ceil((elem.scrollHeight - elemData.baseScrollHeight) / elemData.fontSize) || 1;
    }, []);
    const onElemRef = (0,react.useCallback)((elem)=>{
        if (!elem) {
            return;
        }
        const value = elem.value;
        elem.value = "";
        const baseScrollHeight = elem.scrollHeight;
        elem.value = value;
        // TODO: Probably getComputedStyle doesn't always return px. Need to convert
        const fontSize = parseInt(getComputedStyle(elem).getPropertyValue("font-size"), 10);
        setElemData({
            fontSize,
            baseScrollHeight
        });
        updateElementSize(elem, {
            fontSize,
            baseScrollHeight
        });
    }, [
        updateElementSize
    ]);
    const onTextareaInput = (0,react.useCallback)((e)=>{
        if (onInput) {
            onInput(e);
        }
        if (!autoSize || typeof elemData === "undefined") {
            return;
        }
        updateElementSize(e.currentTarget, elemData);
    }, [
        autoSize,
        elemData,
        updateElementSize,
        onInput
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* clsx */.W)((form_module_default()).textarea, autoSize && (form_module_default()).textarea_autosizeable, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
            defaultValue: defaultValue,
            ref: onElemRef,
            rows: autoSize ? 1 : 0,
            onInput: onTextareaInput,
            name: name,
            placeholder: placeholder,
            onKeyDown: onKeyDown,
            required: required
        })
    });
}

// EXTERNAL MODULE: ../node_modules/react-select/async-creatable/dist/react-select-async-creatable.esm.js + 2 modules
var react_select_async_creatable_esm = __webpack_require__(5528);
;// CONCATENATED MODULE: ./features/ui/form/createable-select.tsx




function CreatableSelect(props) {
    const { defaultValue , onChange , placeholder , name , multi , validationError , label , options , noOptionsMessage  } = props;
    const inputRef = (0,react.useRef)();
    const onInputRef = (0,react.useCallback)((elem)=>{
        inputRef.current = elem;
        if (inputRef.current) {
            inputRef.current.value = defaultValue ? JSON.stringify(defaultValue) : multi ? "[]" : "";
        }
    }, [
        multi,
        defaultValue
    ]);
    const onSelectChange = (0,react.useCallback)((values)=>{
        if (inputRef.current) {
            inputRef.current.value = JSON.stringify(values);
        }
        if (onChange) {
            // @ts-expect-error: TODO: fix
            onChange(Array.isArray(values) ? [
                ...values
            ] : values);
        }
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (form_module_default()).select,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                children: label
            }),
            name && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: onInputRef,
                type: "hidden",
                name: name + "--json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_async_creatable_esm/* default */.Z, {
                placeholder: placeholder,
                noOptionsMessage: ()=>noOptionsMessage || null,
                defaultValue: defaultValue,
                onChange: onSelectChange,
                options: options,
                isMulti: multi,
                classNamePrefix: "react-select"
            }),
            validationError && (Array.isArray(validationError) ? validationError : [
                validationError
            ]).map((error, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (form_module_default()).form__validationError,
                    children: error
                }, index))
        ]
    });
}

;// CONCATENATED MODULE: ./features/ui/form/index.tsx







/***/ }),

/***/ 3634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ Main; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ./features/ui/main/styles.module.scss
var styles_module = __webpack_require__(751);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./features/ui/sidebar/styles.module.scss
var sidebar_styles_module = __webpack_require__(2642);
var sidebar_styles_module_default = /*#__PURE__*/__webpack_require__.n(sidebar_styles_module);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./features/ui/user/styles.module.scss
var user_styles_module = __webpack_require__(4081);
var user_styles_module_default = /*#__PURE__*/__webpack_require__.n(user_styles_module);
// EXTERNAL MODULE: ../node_modules/next/image.js
var next_image = __webpack_require__(8579);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./features/user/index.ts + 3 modules
var features_user = __webpack_require__(1453);
;// CONCATENATED MODULE: ./features/ui/user/use-user.ts



function useUser() {
    const user = (0,features_user/* useUser */.aF)();
    const logout = (0,features_user/* useLogout */.aU)();
    const [isActive, setIsActive] = (0,react.useState)(false);
    const userRef = (0,react.useRef)(null);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const onClick = (e)=>{
            var ref;
            if (e.target instanceof Node && ((ref = userRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
                if (!user.data) {
                    router.push("/").catch(console.error);
                } else {
                    setIsActive(!isActive);
                }
            } else {
                setIsActive(false);
            }
        };
        const onLinkClick = (e)=>{
            e.preventDefault();
        };
        const linkRef = userRef.current;
        linkRef === null || linkRef === void 0 ? void 0 : linkRef.addEventListener("click", onLinkClick);
        window.addEventListener("click", onClick);
        return ()=>{
            window.removeEventListener("click", onClick);
            linkRef === null || linkRef === void 0 ? void 0 : linkRef.removeEventListener("click", onLinkClick);
        };
    }, [
        user,
        isActive,
        router
    ]);
    const onLogout = (0,react.useCallback)((e)=>{
        e.preventDefault();
        logout.mutate();
    }, [
        logout
    ]);
    return {
        onLogout,
        userRef,
        isActive,
        user: user.data
    };
}

// EXTERNAL MODULE: ./features/i18n/index.ts + 2 modules
var features_i18n = __webpack_require__(9194);
// EXTERNAL MODULE: ../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(8944);
;// CONCATENATED MODULE: ./public/logo.jpg
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.16c6eb36.jpg","height":318,"width":318,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABQEBAQAAAAAAAAAAAAAAAAAAAwT/2gAMAwEAAhADEAAAAKwoL//EAB4QAAECBwEAAAAAAAAAAAAAAAIDBAABBQYTQlFT/9oACAEBAAE/AErlZlWTYZi8xLSavI//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwCP/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAIAQMBAT8Ar//Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./features/ui/user/user.tsx








function User(props) {
    const { isActive , userRef , user , onLogout  } = useUser();
    const { i18n  } = (0,features_i18n/* useI18n */.QT)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (user_styles_module_default()).user,
            props.className,
            isActive && (user_styles_module_default()).user__active
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                ref: userRef,
                className: (0,clsx_m/* clsx */.W)((user_styles_module_default()).user__icon, user && (user_styles_module_default())["user__icon--active"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (user_styles_module_default()).logo,
                    alt: "",
                    src: logo,
                    quality: 90,
                    fill: true,
                    priority: true
                })
            }),
            user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (user_styles_module_default()).user__menu,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: (user_styles_module_default())["user__menu-link"],
                            href: "/",
                            children: i18n("homeMenuItem")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: (user_styles_module_default())["user__menu-link"],
                            href: "/draft/new",
                            children: i18n("newDraftMenuItem")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: (user_styles_module_default())["user__menu-link"],
                            href: "/drafts",
                            children: i18n("draftsMenuItem")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#",
                            onClick: onLogout,
                            className: (user_styles_module_default())["user__menu-link"],
                            children: i18n("logOutMenuItem")
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/ui/user/index.tsx


// EXTERNAL MODULE: ../node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__(2312);
;// CONCATENATED MODULE: ./features/ui/sidebar/sidebar.tsx
/* provided dependency */ var process = __webpack_require__(4284);








function Sidebar() {
    const { i18n  } = (0,features_i18n/* useI18n */.QT)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (sidebar_styles_module_default()).sidebar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(User, {
                className: (0,clsx_m/* clsx */.W)((sidebar_styles_module_default()).sidebar__logo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (0,clsx_m/* clsx */.W)((sidebar_styles_module_default()).sidebar__menu, (sidebar_styles_module_default()).menu),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).menu__title,
                        children: i18n("tagsMenu")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).menu__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            className: (sidebar_styles_module_default()).menu__link,
                            href: i18n("articlesSectionLink"),
                            children: [
                                "#",
                                i18n("articlesSection")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).menu__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            className: (sidebar_styles_module_default()).menu__link,
                            href: i18n("projectsSectionLink"),
                            children: [
                                "#",
                                i18n("projectsSection")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).menu__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            className: (sidebar_styles_module_default()).menu__link,
                            href: i18n("photosSectionLink"),
                            children: [
                                "#",
                                i18n("photosSection")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).menu__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            className: (sidebar_styles_module_default()).menu__link,
                            href: i18n("translationsSectionLink"),
                            children: [
                                "#",
                                i18n("translationsSection")
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (0,clsx_m/* clsx */.W)((sidebar_styles_module_default()).sidebar__contacts, (sidebar_styles_module_default()).contacts),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).contacts__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "mailto:alexander@lsndr.com",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RiMailLine */.Azx, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).contacts__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://instagram.com/sasharv",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RiInstagramLine */.Adh, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (sidebar_styles_module_default()).contacts__item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://t.me/someoneiswrong",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RiTelegramLine */.EPM, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (0,clsx_m/* clsx */.W)((sidebar_styles_module_default()).contacts__item, (sidebar_styles_module_default())["contacts__item--hide-on-mobile"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://github.com/lsndr",
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RiGithubFill */.q7V, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (0,clsx_m/* clsx */.W)((sidebar_styles_module_default()).sidebar__languages, (sidebar_styles_module_default()).languages),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (0,clsx_m/* clsx */.W)((sidebar_styles_module_default()).languages__item, router.locale === "ru" && (sidebar_styles_module_default()).languages__item_active),
                        children: typeof process.env["NEXT_PUBLIC_RU_DOMAIN"] === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "//" + process.env["NEXT_PUBLIC_RU_DOMAIN"],
                            className: (sidebar_styles_module_default()).languages__link,
                            children: "RU"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: (sidebar_styles_module_default()).languages__link,
                            href: "/",
                            locale: "ru",
                            children: "RU"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (0,clsx_m/* clsx */.W)((sidebar_styles_module_default()).languages__item, router.locale === "en" && (sidebar_styles_module_default()).languages__item_active),
                        children: typeof process.env["NEXT_PUBLIC_EN_DOMAIN"] === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "//" + process.env["NEXT_PUBLIC_EN_DOMAIN"],
                            className: (sidebar_styles_module_default()).languages__link,
                            children: "EN"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: (sidebar_styles_module_default()).languages__link,
                            href: "/",
                            locale: "en",
                            children: "EN"
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./features/ui/sidebar/index.tsx


;// CONCATENATED MODULE: ./features/ui/main/main.tsx




function Main(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        className: (0,clsx_m/* clsx */.W)((styles_module_default()).main, props.className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* clsx */.W)((styles_module_default()).main__container, (styles_module_default()).container),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* clsx */.W)((styles_module_default())["container__left-sidebar"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {}),
                        props.leftSidebar
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* clsx */.W)((styles_module_default()).container__content),
                    children: props.children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* clsx */.W)((styles_module_default())["container__right-sidebar"]),
                    children: props.rightSidebar
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./features/ui/main/index.tsx



/***/ }),

/***/ 1453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f0": function() { return /* reexport */ useLogin; },
  "aU": function() { return /* reexport */ useLogout; },
  "aF": function() { return /* reexport */ useUser; }
});

// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./features/shared/api/index.ts + 9 modules
var shared_api = __webpack_require__(5815);
;// CONCATENATED MODULE: ./features/user/use-user.ts



function useUser() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { redirectAuthedTo , redirectUnauthedTo , staleTime =60000 , refetchInterval =60000  } = props;
    const router = (0,next_router.useRouter)();
    const api = (0,shared_api/* useApi */.h_)();
    const { setToken , hasToken  } = (0,shared_api/* useApiCredentials */.d9)();
    const userQuery = (0,shared_api/* useApiQuery */.WE)("api/user", async ()=>{
        try {
            const res = await api.user.getMe();
            return res.data;
        } catch (e) {
            if (e instanceof Response && e.status === 403) {
                setToken(null);
                return;
            }
            throw e;
        }
    }, {
        enabled: hasToken,
        staleTime,
        refetchInterval
    });
    (0,react.useEffect)(()=>{
        if ((!hasToken || !userQuery.isLoading && !userQuery.data) && redirectUnauthedTo) {
            router.push(redirectUnauthedTo);
        } else if (!userQuery.isLoading && userQuery.data && redirectAuthedTo) {
            router.push(redirectAuthedTo);
        }
    }, [
        userQuery,
        hasToken,
        redirectAuthedTo,
        redirectUnauthedTo,
        router
    ]);
    return userQuery;
}

// EXTERNAL MODULE: ../node_modules/react-query/es/index.js
var es = __webpack_require__(6552);
;// CONCATENATED MODULE: ./features/user/use-login.ts


function useLogin() {
    const api = (0,shared_api/* useApi */.h_)();
    const { setToken  } = (0,shared_api/* useApiCredentials */.d9)();
    const queryClient = (0,es.useQueryClient)();
    const loginMutation = (0,es.useMutation)("/api/user/login", async (payload)=>{
        const res = await api.auth.login(payload);
        return res.data;
    }, {
        onSuccess: (data)=>{
            const expiresAt = new Date(data.expiresAt);
            setToken({
                accessToken: data.accessToken,
                expiresAt
            });
            queryClient.invalidateQueries("api/user");
        }
    });
    return loginMutation;
}

;// CONCATENATED MODULE: ./features/user/use-logout.ts


function useLogout() {
    const api = (0,shared_api/* useApi */.h_)();
    const { setToken  } = (0,shared_api/* useApiCredentials */.d9)();
    const queryClient = (0,es.useQueryClient)();
    const logoutMutation = (0,es.useMutation)("/api/user/login", async ()=>{
        await api.auth.logout();
    }, {
        onSuccess: ()=>{
            setToken(null);
            queryClient.setQueriesData("api/user", undefined);
        }
    });
    return logoutMutation;
}

;// CONCATENATED MODULE: ./features/user/index.ts





/***/ }),

/***/ 5344:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"form_button__Yqh9Z","button_block":"form_button_block__AE2bz","button_outlined":"form_button_outlined__Y8RTG","button_void":"form_button_void__wxTVq","button_danger":"form_button_danger__jLOaI","button_round":"form_button_round___hnUx","button_spinning":"form_button_spinning__r9KNb","spin":"form_spin__dLYhE","select":"form_select__H5vHe","input":"form_input__EWhxY","textarea":"form_textarea__4Eoqd","textarea_autosizeable":"form_textarea_autosizeable__yGMYi","form":"form_form__TMa1e","form__validationError":"form_form__validationError__Ake9L"};

/***/ }),

/***/ 751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__iEeM1","main__container":"styles_main__container__RUNXY","container":"styles_container__ve_zh","container__left-sidebar":"styles_container__left-sidebar__sf_eO","container__content":"styles_container__content__LjJjm","container__right-sidebar":"styles_container__right-sidebar__GLt1i"};

/***/ }),

/***/ 2642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu___xeua","menu__title":"styles_menu__title__CFwDX","menu__item":"styles_menu__item__vNDAx","menu__item_disabled":"styles_menu__item_disabled__1i3AF","menu__link":"styles_menu__link__8Ql3u","menu__delimiter":"styles_menu__delimiter__Sz1EA","menu__link_icon":"styles_menu__link_icon__VIwxb","sidebar":"styles_sidebar__iWSIy","sidebar__logo":"styles_sidebar__logo__Hcn_6","sidebar__menu":"styles_sidebar__menu__DS_jx","sidebar__contacts":"styles_sidebar__contacts__To1pX","contacts":"styles_contacts__QRawG","contacts__item--hide-on-mobile":"styles_contacts__item--hide-on-mobile__kIags","contacts__item":"styles_contacts__item__Q4QL0","languages":"styles_languages__ap94n","languages__item":"styles_languages__item__WljIP","languages__item_active":"styles_languages__item_active__oL1NY"};

/***/ }),

/***/ 4081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"user":"styles_user__iFTM5","user__active":"styles_user__active___6PxQ","user__menu":"styles_user__menu__pGFut","user__icon":"styles_user__icon__8_kec","user__icon--active":"styles_user__icon--active__NUVQk","user__menu-link":"styles_user__menu-link__Ts1Up"};

/***/ })

}]);